import Screening from "components/containers/Screening"
import { useParams } from "react-router-dom"
import Layout from "./Layout"
import BackButton from "../../shared/buttons/BackButton"

const HistoryAnamnesis = () => {
  const { id } = useParams()

  return (
    <Layout>
      <BackButton />
      <Screening screening_id={id} />
    </Layout>
  )
}

export default HistoryAnamnesis
